export const showMediaImageWindow = (mediaFileUrl: string): void => {
  const mediaWindow = window.open('', '', `fullscreen=1,scrollbars=1,resizable=1`)
  const html = windowTemplate.replace('{{url}}', mediaFileUrl).replace('{{title}}', 'Image')

  if (mediaWindow) {
    mediaWindow.document.title = 'Image'
    mediaWindow.document.open()
    mediaWindow.document.write(html)
    mediaWindow.document.location.href = '#'
    mediaWindow.document.close()
  }
}

const windowTemplate = `
<!DOCTYPE html>
<html lang="en" style="height:100%;">
    <head>
        <meta charset="utf-8">
        <title>{{title}}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <style>
        body {
            padding:0;
            margin:0;
            height:100%;
            overflow: hidden;
            background-color: #262626;
            text-align:center;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .image-wrapper {
            margin: auto;
            overflow: auto;
            height: 100%;
        }
        #image-viewer {
            margin: auto;
            height: 100%;
            display: none;
        }
        .icon-wrapper {
            display: flex;
            flex-direction: row;
            width: auto;
            overflow: hidden;
            height: 80px;
            align-items: center;
        }
        .icon {
            cursor: pointer;
            width: 50px;
            margin: 10px 0;
            color: #C9C9C9;
            fill: #C9C9C9;
            position: relative;
            z-index: 1;
        }
        .icon:hover {
            opacity: 0.8;
        }
        .icon svg {
            height: 20px;
            width: 20px;
        }
        </style>
    </head>
    <body>
        <div id="image-block" class="image-wrapper">
            <img id="image-viewer" src="{{url}}" alt="" />
        </div>
        <div class="icon-wrapper">
            <div class="icon icon-reload">
                <svg id="zoom-in-button" viewBox="64 64 896 896" focusable="false" data-icon="zoom-in" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path></svg>
            </div>
            <div class="icon icon-reload">
                <svg id="rotate-button" viewBox="64 64 896 896" focusable="false" data-icon="reload" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"></path></svg>
            </div>
            <div class="icon icon-reload">
                <svg id="zoom-out-button" viewBox="64 64 896 896" focusable="false" data-icon="zoom-out" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path></svg>
            </div>
        </div>
        <script>
        (function() {
            var imgBlock = document.getElementById('image-block')
            var img = document.getElementById('image-viewer')
            var rotateButton = document.getElementById('rotate-button')
            var zoomInButton = document.getElementById('zoom-in-button')
            var zoomOutButton = document.getElementById('zoom-out-button')

            var navigationHeight = 80
            var initialHeight = 0
            var initialWidth = 0
            var height = 0
            var width = 0
            var rotate = 0
            var index = 0

            var maxScale = 3
            var minScale = 1
            var zoomStatus = 1

            var isLandscape = false
            var isPortrait = false
            var isSquare = false

            var init = function() {
                initialHeight = img.naturalHeight
                initialWidth = img.naturalWidth
                height = window.innerHeight - (navigationHeight + 10)
                width = window.innerWidth - (navigationHeight + 10)

                var imageOrientation = calculateOrientation(initialHeight, initialWidth)
                isLandscape = imageOrientation.isLandscape
                isPortrait = imageOrientation.isPortrait
                isSquare = imageOrientation.isSquare

                resizeFactoryByOrientation(isLandscape, isPortrait, isSquare)
                showImage()
            }

            var resizeImage = function() {
                height = window.innerHeight - (navigationHeight + 10)
                width = window.innerWidth - (navigationHeight + 10)
                resizeFactoryByOrientation(isLandscape, isPortrait, isSquare)
            }

            var applyTransform = function(rotate, translateX = 0) {
                img.style.transform = 'rotate(' + rotate + 'deg) translateX(' + translateX + 'px)';

              }

            var rotateImage = function() {
                rotateButton.addEventListener('click', function() {
                    rotate += 90
                    index++
                    var translate = (initialWidth - initialHeight) / 2
                    if(isLandscape){
                           switch (rotate % 360) {
                            case 90:
                              applyTransform(rotate, translate);
                              break;
                            case 270:
                              applyTransform(rotate, -translate);
                              break;
                            default:
                              applyTransform(rotate);
                          }
                    }
                    else{
                        applyTransform(rotate);

                    }
                   
                })
            }

            var zoomInImage = function() {
                zoomInButton.addEventListener('click', function() {
                    if (zoomStatus <= maxScale) {
                        zoomStatus++
                        resizeFactoryByOrientation(isLandscape, isPortrait, isSquare)
                    }
                })
            }

            var zoomOutImage = function() {
                zoomOutButton.addEventListener('click', function() {
                    if (zoomStatus > minScale) {
                        zoomStatus--
                        resizeFactoryByOrientation(isLandscape, isPortrait, isSquare)
                    }
                })
            }

            window.addEventListener('load', function() {
              init()
              rotateImage()
              zoomInImage()
              zoomOutImage()
            })
            window.addEventListener('resize', resizeImage)

            function resizeFactoryByOrientation(isLandscape, isPortrait, isSquare) {
                if (isLandscape) {
                    img.style.height = 'auto'
                    img.style.width = width * zoomStatus + 'px'
                    imgBlock.style.width = window.innerWidth + 'px'
                }
                if (isPortrait) {
                    img.style.height = height * zoomStatus + 'px'
                    img.style.width = 'auto'
                    imgBlock.style.width = window.innerWidth + 'px'
                }
                if (isSquare) {
                    img.style.height = height * zoomStatus + 'px'
                    img.style.width = height * zoomStatus + 'px'
                    imgBlock.style.width = window.innerWidth + 'px'
                }
            }

            function showImage() {
                img.style.display = 'block'
            }

            function calculateOrientation(height, width) {
                if (width > height) {
                    return { isLandscape: true, isPortrait: false, isSquare: false }
                } else if (width < height) {
                    return { isLandscape: false, isPortrait: true, isSquare: false }
                } else {
                    return { isLandscape: false, isPortrait: false, isSquare: true }
                }
            }
        })()
        </script>
    </body>
</html>`
